/**
 * GEO const symbols.
 * @constant
 * @type {Object}
 */


const GEO = {
    CB_FN: 'cbfn',
    RES_DATA: 'geoResData',
    RES_TYPE: 'geoResType',
    TIME_OUT: 'timeout',
    GEO_CB_RES: 'cbresfn',
    CHANGE_TO:   '\'',
    CHANGE_FROM:'##abf#fcd##'
};


export {GEO};